<template>
  <div class="message-timeline">
    <el-timeline>
      <MessageTimelineItem v-for="message in messageList"
                           :key="message.id"
                           :message="message"
                           @delete="deleteMessage">
      </MessageTimelineItem>
    </el-timeline>
  </div>
</template>

<script>
import MessageTimelineItem from './MessageTimelineItem'
export default {
  name: 'MessageTimeline',
  components: {
    MessageTimelineItem
  },
  props: {
    messageList: {
      type: Array,
      required: true
    }
  },
  methods: {
    deleteMessage (message) {
      let index = this.messageList.indexOf(message)
      if (index >= 0) {
        this.messageList.splice(index, 1)
      }
    }
  }
}
</script>

<style lang="scss">
  .message-timeline {
    .el-timeline {
      padding: 15px 0 15px 15px;
    }
  }
</style>
